<div class="pdf-page app-aul-012-24" id="aul01224">
  <!-- <app-policy-header></app-policy-header>-->
  <p class="font-large" style="text-align: center"><b>PRIVACY NOTICE</b></p>
  <p class="font-medium">
    <b
      >We want you to know how we protect the confidentiality of your non-public
      personal information. We want you to know how and why we use and disclose
      the information that we have about you. The following describes our
      policies and practices for securing the privacy of your information.</b
    >
  </p>
  <br />
  <div class="font-small">
    <p>
      <b>Information we collect: </b><br />
      The non-public information that we collect about you includes, but is not
      limited to: Information contained in applications or other forms that you
      submit to us, such as name address and social security number; Information
      about your transactions with our affiliates or other third parties, such
      as balances and payment history: Information we receive from a
      consumer-reporting agency, such as credit-worthiness or credit history.
    </p>
    <p>
      <b>Information we disclose: </b><br />
      We disclose the information that we have when it is necessary to provide
      our products and services. We may also disclose information when the law
      requires or permits us to do so.
    </p>
    <p>
      <b>Confidentiality and security: </b><br />
      Only our employees and others who need the information to service your
      account have access to your personal information. We have measures in
      place to secure our paper files and computer systems.
    </p>
    <p>
      <b>Right to access or correct your personal information: </b><br />
      You have a right to request access to or correction of your personal
      information that is in our possession.
    </p>
    <p>
      <b>Contacting us:</b><br />
      If you have any questions about this privacy notice or would like to learn
      more about how we protect your privacy, contact the
      <b>licensed insurance professional </b>who assisted you in the purchase of
      this insurance. We can provide a more detailed statement of our privacy
      practices upon request.
    </p>
  </div>
</div>
